/* eslint-disable no-unused-expressions */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";

// import { useNavigate } from "react-router-dom";
// import { updateToken } from "../axios";   // don't use that it make a big problem with build u can use it in any component not here

const allowedRoles = ["ShippingAdmin", "SuperAdmin"];

const initialState = {
  admin: {},
  loading: true,
  error: "",
  token: "",
  refresh: "",
  type: "",
};

export const adminLogin = createAsyncThunk(
  "admin/login",
  async (data, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    try {
      const res = await axios.post("auth/api/v1/token/", data);
      if (!allowedRoles.includes(res.data.role)) {
        return rejectWithValue("Sorry, you don't have permission to login.");
      }

      // Cookies.set("logs", res.data.access);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// i send him here bc he has no token so we will not work through the token but the refresh token

let isRefreshing = false;

export const refresh = createAsyncThunk(
  "admin/refresh",
  async (_, thunkApi) => {
    const { rejectWithValue } = thunkApi;

    if (isRefreshing) {
      return rejectWithValue("Token refresh already in progress.");
    }

    isRefreshing = true;

    const adminRefresh = Cookies.get("logss");
    if (!adminRefresh) {
      Cookies.remove("logss");
      Cookies.remove("access");
      isRefreshing = false;
      return rejectWithValue("No refresh token found. Please log in again.");
    }

    try {
      // Attempt to refresh token using the stored refresh token
      const res = await axios.post("auth/api/v1/token/refresh/", {
        refresh: adminRefresh,
      });
      // Save new tokens securely
      Cookies.set("logss", res.data.refresh, { expires: 7, path: "/" }); // 7 days for refresh token
      Cookies.set("access", res.data.access, { expires: 1, path: "/" }); // 1 day for access token
      isRefreshing = false;
      return res.data;
    } catch (error) {
      Cookies.remove("logss");
      Cookies.remove("access");
      isRefreshing = false;
      return rejectWithValue("Session expired. Please log in again.");
    }
  },
);

export const me = createAsyncThunk("admin/me", async (data, thunkApi) => {
  const { rejectWithValue, dispatch } = thunkApi;
  try {
    const res = await axios.get("auth/api/v1/profile/", {
      headers: { Authorization: `Bearer ${data}` },
    });
    return res.data;
  } catch (error) {
    if (error.response.statusCode === 401) {
      dispatch("admin/refresh");
    }
    return rejectWithValue(error.message);
  }
});

const adminSlice = createSlice({
  name: "admin",
  initialState: initialState,
  reducers: {
    changeLoading(state, action) {
      state.loading = action.payload;
    },
    clearToken(state) {
      state.token = "";
      state.admin = {};
    },
  },
  extraReducers: (builder) => {
    builder.addCase(adminLogin.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(adminLogin.fulfilled, (state, action) => {
      state.loading = false;
      state.token = action.payload.access;
      state.refresh = action.payload.refresh;
      state.type = action.payload.role;
    });
    builder.addCase(adminLogin.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // refresh

    builder.addCase(refresh.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(refresh.fulfilled, (state, action) => {
      state.loading = false;
      // state.admin = action.payload;
      state.token = action?.payload?.access || null;
      state.refresh = action?.payload?.refresh || null;
    });
    builder.addCase(refresh.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state = { ...state, admin: {}, token: "" };
    });

    // me  .. profile

    builder.addCase(me.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(me.fulfilled, (state, action) => {
      state.loading = false;
      state.admin = action.payload;
      state.type = action.payload.role;
      // state.token = action.payload.access;
    });
    builder.addCase(me.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state = { ...state, admin: {}, token: "" };
    });
  },
});

export const { changeLoading, clearToken } = adminSlice.actions;
export default adminSlice.reducer;
